declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[]
  }
}

/**
 * Function used to ensure ALL page views get triggered as their
 * routes are entered.
 *
 * This should be called whenever a page is entered, to add a
 * virtual page view event to the GTM datalayer, which is effectively a
 * queue of things to process. Note that GTM has to be set up to listen to
 * these virtual events
 */
export const gtmVirtualPageView = (
  rest: Record<string, unknown>,
  eventName = 'VirtualPageView',
) => {
  window.dataLayer?.push({
    event: eventName,
    ...rest,
  })
}
